import { Claim } from "./claim";

export class NotificationRecipient {
	id: string;
    name: string;
    email: string;
    phone: string;
    selected: boolean;
	notificationType: number;
	claims: Array<Claim>;

	
}
